module.exports = __webpack_public_path__ + "img/topTitle.ef27694a.svg";